"use client";

import React, { useState, useEffect } from "react";
import { Button, Label } from "semantic-ui-react";
import { fetchUserAttributes } from "aws-amplify/auth";

export default function AddPhotosButton({ neighborhoodId, nhdetails, page }) {
  const [loggedin, setLoggedin] = useState(false);

  useEffect(() => {
    const checkUserStatus = async () => {
      try {
        await fetchUserAttributes();
        setLoggedin(true);
      } catch (error) {
        setLoggedin(false);
      }
    };

    checkUserStatus();
  }, []);

  const handleAddPhotos = () => {
    if (loggedin) {
      if (page === "city") {
        if (nhdetails && nhdetails.length > 0) {
          localStorage.setItem("citydetails", JSON.stringify(nhdetails));

          const cityData = nhdetails[0];
          localStorage.setItem("cityname", cityData?.postalcity_name || "");
          localStorage.setItem(
            "statename",
            cityData?.label?.split(",")?.pop()?.trim() || "",
          );
        }

        localStorage.setItem("cityId", neighborhoodId || "");

        if (typeof window !== "undefined") {
          window.location.href = "/CityImages";
        }
      } else {
        if (nhdetails && nhdetails.length > 0) {
          localStorage.setItem("nhdetails", JSON.stringify(nhdetails));
        }

        localStorage.setItem(
          "neighborhoodId",
          neighborhoodId || "60e879f2-b1b0-4ce9-bb26-f06bb9631e98",
        );

        if (typeof window !== "undefined") {
          window.location.href = "/NhImages";
        }
      }
    } else {
      if (typeof window !== "undefined") {
        localStorage.setItem("previous_url", window.location.href);
      }

      const signUpBtn = document.getElementById("sign_up_btn");
      if (signUpBtn) {
        signUpBtn.click();
      }
    }
  };

  return (
    <div className="add_photos" style={{ display: "inherit", width: "auto" }}>
      <Button
        as="div"
        labelPosition="right"
        floated="right"
        onClick={handleAddPhotos}
        className="theme_blue btn_blue"
      >
        <Button icon="camera retro" className="btn_blue_bg" />
        <Label
          as="a"
          name="saveNeighbor"
          content="Add Photos"
          basic
          pointing="left"
          onClick={handleAddPhotos}
          className="theme_blue btn_blue"
        />
      </Button>
    </div>
  );
}
